// extracted by mini-css-extract-plugin
export default {"wrapper":"oyp4nlCxoqDlB2BRMwvS","editWrapper":"zZyCtgvzmBClSKfKMxXw","editWrapperBig":"c4_f8yw2WGTwG7cxaY3Q"};